import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Keypad = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M7.795 4.12H6.658c-.551 0-1.001.382-1.001.857v.967c0 .466.45.857 1.001.857h1.137c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM12.57 4.12h-1.136c-.551 0-1.001.382-1.001.857v.967c0 .466.45.857 1 .857h1.138c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM17.372 4.12h-1.137c-.551 0-1 .382-1 .857v.967c0 .466.449.857 1 .857h1.137c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM7.795 8.531H6.658c-.551 0-1.001.382-1.001.857v.967c0 .466.45.857 1.001.857h1.137c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM12.57 8.531h-1.136c-.551 0-1.001.382-1.001.857v.967c0 .466.45.857 1 .857h1.138c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM17.372 8.531h-1.137c-.551 0-1 .382-1 .857v.967c0 .466.449.857 1 .857h1.137c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM7.795 13.078H6.658c-.551 0-1.001.382-1.001.857v.967c0 .466.45.857 1.001.857h1.137c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM12.57 13.078h-1.136c-.551 0-1.001.382-1.001.857v.967c0 .466.45.857 1 .857h1.138c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM17.372 13.078h-1.137c-.551 0-1 .382-1 .857v.967c0 .466.449.857 1 .857h1.137c.551 0 1-.382 1-.857v-.967c0-.467-.449-.857-1-.857ZM12.57 17.32h-1.136c-.551 0-1.001.381-1.001.856v.967c0 .467.45.857 1 .857h1.138c.551 0 1-.382 1-.857v-.967c0-.466-.449-.857-1-.857Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Keypad
